export const MAIN = 'MAIN';
export const SAVE_FOR_LATER = 'SAVE_FOR_LATER';